import {Box, CardHeader, Link, Switch} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';

const ToggleFilter = ({
  title,
  description,
  onChange,
  learnMore,
  checked,
  disabled,
  ...props
}) => {
  const {t} = useTranslation();

  const subheader = !learnMore ? (
    description
  ) : (
    <Box>
      {description}
      <Link
        href={learnMore}
        target="_blank"
        underline="always"
        variant="caption"
        sx={{marginLeft: 0.5}}
        rel="noreferrer noopener"
      >
        {t('filters.linkToggleLearnMore')}
      </Link>
    </Box>
  );
  return (
    <CardHeader
      title={title}
      subheader={subheader}
      slotProps={{
        title: {
          variant: 'body1',
          gutterBottom: true,
          color: disabled ? 'text.secondary' : 'text.primary',
        },
        subheader: {
          variant: 'caption',
          color: disabled ? 'text.secondary' : 'text.primary',
        },
      }}
      action={
        <Switch
          color="primary"
          edge="end"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
        />
      }
      sx={{
        paddingX: 0,
        '& .MuiCardHeader-action': {
          alignSelf: 'center',
        },
      }}
      {...props}
    />
  );
};

ToggleFilter.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  learnMore: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default ToggleFilter;
